import { smoPost, smoGet, smoPut } from "@/plugins/request";

export default {
  login: (data) =>
    smoPost("/login", data, {
      headers: { isToken: false, repeatSubmit: false },
    }),
  getCodeImg: () =>
    smoGet("/captchaImage", {}, { headers: { isToken: false }, timeout: 20000 }),
  getInfo: () => smoGet("/getInfo"),
  logout: () => smoPost("/logout"),
  sendResetCode: (data) =>
    smoPost("/open/loginPw/sendCode", data, { headers: { isToken: false } }),
  resetPasswordByCode: (data) =>
    smoPut("/open/loginPw/resetPasswordWithCode", data, {
      headers: { isToken: false },
    }),
};
